module.exports = __webpack_public_path__ + "assets/img/ovlay-back.0aa94cb1.png";